module.exports = __webpack_public_path__ + "img/teacher_img2.f435ef24.png";